import reactManifest from 'react-manifest';

interface IManifestIcon {
  src: string;
  sizes: string;
}

interface IManifest {
  name?: string;
  short_name?: string;
  start_url?: string;
  display?: string;
  orientation?: string;
  theme_color?: string;
  background_color?: string;
  icons?: IManifestIcon[];
}

interface IUpdateManifestParam {
  manifest: IManifest;
}

export const updateManifest = ({ manifest }: IUpdateManifestParam) => {
  const MANIFEST_LINK_TAG_ID = '#manifest';

  reactManifest.update(manifest, MANIFEST_LINK_TAG_ID);
};
